import React, { useEffect, useState } from "react";
import { toast } from "sonner";
import { Plus } from "lucide-react";
import { api, errMsg } from "@/lib/api";
import { useApp } from "@/context/AppContext";
import { PageHeader, DataTable, Badge } from "@/components/common";

export default function Locations() {
  const { can, loadSession } = useApp();
  const [rows, setRows] = useState([]);
  const [name, setName] = useState("");
  const [address, setAddress] = useState("");
  const load = () => api.get("/locations").then((r) => setRows(r.data));
  useEffect(() => { load(); }, []);
  const add = async () => {
    try { await api.post("/locations", { name, address }); setName(""); setAddress(""); toast.success("Location added"); load(); loadSession(); } catch (e) { toast.error(errMsg(e)); }
  };
  const toggle = async (l) => { await api.put(`/locations/${l.id}`, { active: !l.active }); load(); };
  const edit = can("action:manage_settings");
  return (
    <div>
      <PageHeader title="Locations" />
      {edit && (
        <div className="panel mb-4 flex flex-col gap-2 p-4 md:flex-row">
          <input className="inp" placeholder="Location name" value={name} onChange={(e) => setName(e.target.value)} data-testid="location-name-input" />
          <input className="inp" placeholder="Address (optional)" value={address} onChange={(e) => setAddress(e.target.value)} data-testid="location-address-input" />
          <button className="btn btn-primary" onClick={add} disabled={!name} data-testid="add-location-btn"><Plus size={14} />Add</button>
        </div>
      )}
      <DataTable testid="locations-table" rows={rows} columns={[{ key: "name", label: "Name" }, { key: "address", label: "Address" },
        { key: "active", label: "Status", render: (r) => <Badge value={r.active ? "ACTIVE" : "INACTIVE"} /> },
        ...(edit ? [{ key: "_a", label: "", sortable: false, render: (r) => <button className="btn btn-ghost btn-sm" onClick={() => toggle(r)} data-testid={`toggle-location-${r.id}`}>{r.active ? "Deactivate" : "Activate"}</button> }] : [])]} />
    </div>
  );
}
